module.exports = __webpack_public_path__ + "static/img/icon_robot.574ee83.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_robot.png
// module id = 746
// module chunks = 1